/* Catalogo — esploratore a faccette.
   Nessuna dipendenza, nessun framework. Legge products-index.json (lo stesso
   indice della ricerca), filtra in memoria e riscrive la griglia.

   Tre scelte che vale la pena spiegare:
   1. i conteggi di ogni faccetta sono calcolati ESCLUDENDO la faccetta stessa
      dai filtri attivi. Se calcolassi i conteggi sul risultato finale, appena
      scegli "Pasticceria" tutte le altre categorie andrebbero a zero e non
      potresti piu' aggiungerne una seconda. E' l'errore classico delle facet.
   2. lo stato vive nella querystring, cosi' una selezione e' un link che si
      manda all'agente. La history usa replaceState: filtrare non deve riempire
      il tasto Indietro di venti passi.
   3. su mobile il pannello e' un livello a se' e si applica con un gesto
      esplicito: aggiornare in tempo reale sotto le dita fa saltare la pagina
      a meta' interazione.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-cx]');
  var CFG = window.SF_CX;
  if (!root || !CFG) return;

  var PAGINA = 60;                // card rese per volta
  var MOBILE = '(max-width: 900px)';

  var el = {
    facets:  root.querySelector('[data-cx-facets]'),
    grid:    root.querySelector('[data-cx-grid]'),
    count:   root.querySelector('[data-cx-count]'),
    chips:   root.querySelector('[data-cx-chips]'),
    q:       root.querySelector('[data-cx-q]'),
    sort:    root.querySelector('[data-cx-sort]'),
    more:    root.querySelector('[data-cx-more]'),
    moreBtn: root.querySelector('[data-cx-morebtn]'),
    empty:   root.querySelector('[data-cx-empty]'),
    side:    root.querySelector('.cx__side'),
    open:    root.querySelector('[data-cx-open]'),
    close:   root.querySelector('[data-cx-close]'),
    scrim:   root.querySelector('[data-cx-scrim]'),
    apply:   root.querySelector('[data-cx-apply]'),
    activeN: root.querySelector('[data-cx-activecount]'),
    reset:   root.querySelector('[data-cx-reset]')
  };

  var dati = [];
  var sel = {};                   // { c: Set, k: Set, v: Set, g: Set }
  var testo = '';
  var ordine = 'cat';
  var visibili = PAGINA;
  var risultato = [];

  CFG.gruppi.forEach(function (g) { sel[g.k] = new Set(); });

  /* ---------------------------------------------------------------- utili */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function valori(p, k) {
    var v = p[k];
    if (Array.isArray(v)) return v;
    if (v === 0 || v === '' || v == null) return [];
    return [String(v)];
  }
  function etichetta(g, v) {
    return (g.etichette && g.etichette[v]) ? g.etichette[v] : v;
  }
  function mobile() { return window.matchMedia(MOBILE).matches; }

  /* Un prodotto passa se soddisfa OGNI gruppo attivo (AND fra gruppi),
     bastando UN valore per gruppo (OR dentro il gruppo). E' il comportamento
     che la gente si aspetta: "pasticceria O finger food, ma solo per il bar". */
  function passa(p, salta) {
    for (var i = 0; i < CFG.gruppi.length; i++) {
      var g = CFG.gruppi[i];
      if (g.k === salta) continue;
      var s = sel[g.k];
      if (!s.size) continue;
      var vs = valori(p, g.k), ok = false;
      for (var j = 0; j < vs.length; j++) { if (s.has(String(vs[j]))) { ok = true; break; } }
      if (!ok) return false;
    }
    if (testo) {
      var fieno = (p.t + ' ' + p.l + ' ' + p.c + ' ' + p.v).toLowerCase();
      var tok = testo.split(/\s+/);
      for (var w = 0; w < tok.length; w++) { if (fieno.indexOf(tok[w]) === -1) return false; }
    }
    return true;
  }

  function calcola() {
    risultato = dati.filter(function (p) { return passa(p, null); });
    if (ordine === 'az') risultato.sort(function (a, b) { return a.t.localeCompare(b.t, 'it'); });
    else if (ordine === 'za') risultato.sort(function (a, b) { return b.t.localeCompare(a.t, 'it'); });
  }

  function attiviTot() {
    return CFG.gruppi.reduce(function (n, g) { return n + sel[g.k].size; }, 0) + (testo ? 1 : 0);
  }

  /* ------------------------------------------------------------- faccette
     Le opzioni si disegnano UNA VOLTA SOLA, con l'universo completo dei valori
     e nell'ordine calcolato sui conteggi totali. Poi a ogni filtro si aggiornano
     solo numero e stato disabilitato.

     Tre difetti che questa forma evita, e che la prima versione aveva tutti e tre:
      · le opzioni a zero sparivano dalla lista invece di disabilitarsi, quindi
        il catalogo sembrava piu' piccolo di quello che e';
      · l'ordine per conteggio si ricalcolava a ogni clic e la lista si
        riordinava sotto le dita;
      · rifare l'innerHTML buttava via il focus, e chi filtra da tastiera
        tornava a inizio pagina a ogni casella spuntata.
  */
  var universo = {};

  function costruisciFacets() {
    var html = '';
    CFG.gruppi.forEach(function (g) {
      var tot = {};
      dati.forEach(function (p) {
        valori(p, g.k).forEach(function (v) { tot[v] = (tot[v] || 0) + 1; });
      });
      var chiavi = Object.keys(tot);
      if (g.soloVere) chiavi = chiavi.filter(function (v) { return v === '1'; });
      chiavi.sort(function (a, b) {
        var d = tot[b] - tot[a];
        return d !== 0 ? d : String(etichetta(g, a)).localeCompare(String(etichetta(g, b)), 'it');
      });
      universo[g.k] = chiavi;
      if (!chiavi.length) return;

      html += '<fieldset class="cx-f"><legend class="cx-f__lab">' + esc(g.label) + '</legend>';
      chiavi.forEach(function (v) {
        html += '<label class="cx-f__o" data-o="' + esc(g.k) + '|' + esc(v) + '">' +
          '<input type="checkbox" data-g="' + esc(g.k) + '" value="' + esc(v) + '">' +
          '<span class="cx-f__t">' + esc(etichetta(g, v)) + '</span>' +
          '<span class="cx-f__n" data-n>0</span></label>';
      });
      if (g.nota) html += '<p class="cx-f__nota">' + esc(g.nota) + '</p>';
      html += '</fieldset>';
    });
    el.facets.innerHTML = html;
  }

  function aggiornaFacets() {
    CFG.gruppi.forEach(function (g) {
      // conteggio con la faccetta stessa esclusa: vedi nota 1 in testa al file
      var base = dati.filter(function (p) { return passa(p, g.k); });
      var conta = {};
      base.forEach(function (p) {
        valori(p, g.k).forEach(function (v) { conta[v] = (conta[v] || 0) + 1; });
      });
      (universo[g.k] || []).forEach(function (v) {
        var lab = el.facets.querySelector('[data-o="' + CSS.escape(g.k + '|' + v) + '"]');
        if (!lab) return;
        var n = conta[v] || 0;
        var box = lab.querySelector('input');
        var on = sel[g.k].has(v);
        lab.querySelector('[data-n]').textContent = n;
        box.checked = on;
        box.disabled = n === 0 && !on;
        lab.classList.toggle('is-off', box.disabled);
      });
    });
  }

  /* ---------------------------------------------------------------- chip */
  function disegnaChips() {
    var out = '';
    CFG.gruppi.forEach(function (g) {
      sel[g.k].forEach(function (v) {
        out += '<button type="button" class="cx-chip" data-rm-g="' + esc(g.k) + '" data-rm-v="' + esc(v) + '"' +
               ' aria-label="' + esc(CFG.t.rimuovi + ' ' + etichetta(g, v)) + '">' +
               '<span class="cx-chip__g">' + esc(g.label) + '</span>' + esc(etichetta(g, v)) +
               '<span class="cx-chip__x" aria-hidden="true">×</span></button>';
      });
    });
    if (testo) {
      out += '<button type="button" class="cx-chip" data-rm-q="1" aria-label="' + esc(CFG.t.rimuovi) + '">' +
             '<span class="cx-chip__g">«»</span>' + esc(testo) + '<span class="cx-chip__x" aria-hidden="true">×</span></button>';
    }
    if (out) out += '<button type="button" class="cx-chip cx-chip--all" data-cx-clear>' + esc(CFG.t.azzera) + '</button>';
    el.chips.innerHTML = out;
    el.chips.hidden = !out;
  }

  /* -------------------------------------------------------------- griglia */
  function card(p) {
    var img = p.i ? p.i.replace('_220x220', '_460x460') : '';
    // Occhiello = categoria, cioe' la stessa parola che sta nella faccetta.
    // Prima era l'ultimo segmento di `linea` e usciva "PULLED", "RIBS",
    // "POLLO FINGER": frammenti che non corrispondono a niente di filtrabile.
    var occhiello = p.c || (p.v || '');
    // `b` = scontorno su bianco. Va mostrato INTERO (contain) sul bianco da cui
    // nasce; una scena riempie il riquadro (cover). Prima erano tutti in cover
    // e sugli scontorni il taglio mangiava i bordi del prodotto.
    var media = 'cx-card__media' + (p.b ? ' cx-card__media--scontorno' : '');
    return '<a class="cx-card" href="' + esc(CFG.root.replace(/\/$/, '')) + '/products/' + esc(p.h) + '">' +
      '<span class="' + media + '">' +
        (img ? '<img src="' + esc(img) + '" alt="' + esc(p.t) + '" loading="lazy" width="460" height="345" draggable="false">' : '<span class="cx-card__ph"></span>') +
      '</span>' +
      '<span class="cx-card__body">' +
        '<span class="cx-card__line">' + esc(occhiello) + '</span>' +
        '<span class="cx-card__t">' + esc(p.t) + '</span>' +
      '</span></a>';
  }

  function disegnaGriglia() {
    var fetta = risultato.slice(0, visibili);
    el.grid.innerHTML = fetta.map(card).join('');
    var resta = risultato.length - fetta.length;
    el.more.hidden = resta <= 0;
    if (resta > 0) el.moreBtn.textContent = CFG.t.altri + ' ' + Math.min(PAGINA, resta);
    el.empty.hidden = risultato.length > 0;
  }

  function disegnaConteggio() {
    var n = risultato.length, tot = dati.length, s;
    if (n === tot) s = CFG.t.tutti.replace('{tot}', tot);
    else if (n === 1) s = CFG.t.conteggio1;
    else s = CFG.t.conteggio.replace('{n}', n).replace('{tot}', tot);
    el.count.textContent = s;
    var na = attiviTot();
    el.activeN.textContent = na;
    el.activeN.hidden = na === 0;
    el.apply.textContent = CFG.t.applica.replace('{n}', n);
  }

  function rendi(azzeraPagina) {
    if (azzeraPagina !== false) visibili = PAGINA;
    calcola();
    aggiornaFacets();
    disegnaChips();
    disegnaGriglia();
    disegnaConteggio();
    scriviUrl();
  }

  /* ------------------------------------------------------------------ URL */
  function scriviUrl() {
    var p = new URLSearchParams();
    CFG.gruppi.forEach(function (g) {
      if (sel[g.k].size) p.set(g.k, Array.from(sel[g.k]).join(','));
    });
    if (testo) p.set('q', testo);
    if (ordine !== 'cat') p.set('o', ordine);
    var qs = p.toString();
    history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + '#catalogo');
  }

  function leggiUrl() {
    var p = new URLSearchParams(location.search);
    CFG.gruppi.forEach(function (g) {
      var v = p.get(g.k);
      if (v) v.split(',').forEach(function (x) { if (x) sel[g.k].add(x); });
    });
    testo = (p.get('q') || '').trim().toLowerCase();
    if (testo) el.q.value = testo;
    var o = p.get('o');
    if (o === 'az' || o === 'za') { ordine = o; el.sort.value = o; }
  }

  /* ---------------------------------------------------------------- mobile */
  function apri() {
    root.classList.add('is-open');
    el.scrim.hidden = false;
    el.open.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    el.side.querySelector('input, button').focus();
  }
  function chiudi() {
    root.classList.remove('is-open');
    el.scrim.hidden = true;
    el.open.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    el.open.focus();
  }

  /* --------------------------------------------------------------- eventi */
  el.facets.addEventListener('change', function (e) {
    var i = e.target.closest('input[type=checkbox]');
    if (!i) return;
    var s = sel[i.dataset.g];
    if (i.checked) s.add(i.value); else s.delete(i.value);
    rendi();
  });

  el.chips.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b) return;
    if (b.hasAttribute('data-cx-clear')) {
      CFG.gruppi.forEach(function (g) { sel[g.k].clear(); });
      testo = ''; el.q.value = '';
    } else if (b.hasAttribute('data-rm-q')) {
      testo = ''; el.q.value = '';
    } else {
      sel[b.dataset.rmG].delete(b.dataset.rmV);
    }
    rendi();
  });

  var timer;
  el.q.addEventListener('input', function () {
    clearTimeout(timer);
    timer = setTimeout(function () { testo = el.q.value.trim().toLowerCase(); rendi(); }, 160);
  });

  el.sort.addEventListener('change', function () { ordine = el.sort.value; rendi(); });
  el.moreBtn.addEventListener('click', function () { visibili += PAGINA; rendi(false); });
  el.reset.addEventListener('click', function () {
    CFG.gruppi.forEach(function (g) { sel[g.k].clear(); });
    testo = ''; el.q.value = ''; rendi();
  });
  el.open.addEventListener('click', apri);
  el.close.addEventListener('click', chiudi);
  el.scrim.addEventListener('click', chiudi);
  el.apply.addEventListener('click', chiudi);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) chiudi();
  });

  /* ------------------------------------------------------------------ via */
  fetch(CFG.src)
    .then(function (r) { return r.json(); })
    .then(function (j) {
      dati = j;
      root.hidden = false;
      leggiUrl();
      costruisciFacets();
      rendi();
      // l'ancora #catalogo la scrive scriviUrl(): non deve far saltare la
      // pagina al primo caricamento, solo rendere condivisibile la selezione
      if (!location.search) history.replaceState(null, '', location.pathname);
    })
    .catch(function () { /* l'indice non risponde: restano le card qui sotto */ });
})();
